import React, { useEffect, useState } from "react";
import {
    PDFViewer,
    Document,
    Page,
    Text,
    View,
    Image,
    StyleSheet
} from "@react-pdf/renderer";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useStore } from "../../shared/hooks/stateStore";
import { routeConfig } from "../../shared/common/constant";
import { convertNumTOWords } from "../../shared/hooks/wordNumb";
import { Skeleton } from "antd";
import header from '../../assets/header.png';
import { companyData } from "../../core/auth";
import { fixedDecimal } from "../../shared/hooks/utils";

const BORDER_COLOR = '#5E5E5E'
const KEY_FONT_COLOR = '#5E5E5E'
const TABLE_HEADER_COLOR = '#D5D5D5'
const WHITE = '#FFFFFF'
const BLACK = '#000000'
const BORDER_STYLE = 'solid'
const BORDER_WIDTH = 1.3
const styles = StyleSheet.create({
    body: {
        paddingLeft: 7,
        paddingRight: 7,
        paddingTop: 7
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderRightWidth: 0,
        borderBottomWidth: 0
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableRowHeight60: {
        margin: "auto",
        flexDirection: "row",
        height: 60
    },
    tableCol: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    tableColCommentNoPadding: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: -2,
        paddingLeft: -3
    },
    tableColComment: {
        marginLeft: '15%',
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderBottomWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    tableColNoRight: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        // borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderRightWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 2
    },
    tableColNoLeftTop: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        // borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        // borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 2
    },
    tableColNoBorder: {
        borderRightWidth: 0,
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 2
    },
    tableColNoPadding: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        paddingTop: 1
    },
    tableCellHeader: {
        margin: "auto",
        //   margin: 5, 
        fontSize: 12,
        fontWeight: 500
    },
    tableColZeroPadding: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 0
    },
    margin3: {
        marginTop: 3,
        marginBottom: 3
    },
    tableCell: {
        // margin: "auto",
        // marginLeft: 5,
        fontSize: 10,
        fontWeight: "black"
    },
    tableCellSmall: {
        // margin: "auto",
        //   margin: 5, 
        fontSize: 8
    },
    height10: {
        height: 10
    },
    height20: {
        height: 20
    },
    height235: {
        height: 25.5
    },
    height255: {
        height: 25.5
    },
    height25: {
        height: 25
    },
    height27: {
        height: 27
    },
    height30: {
        height: 30
    },
    height35: {
        height: 35
    },
    height38: {
        height: 38
    },
    height40: {
        height: 40
    },
    height51: {
        height: 51
    },
    height60: {
        height: 60
    },
    height80: {
        height: 80
    },
    height90: {
        height: 90
    },
    width5: {
        width: "5%"
    },
    width6: {
        width: "6%"
    },
    width7: {
        width: "7%"
    },
    width8: {
        width: "8%"
    },
    width833: {
        width: "8.33%"
    },
    width9: {
        width: "9%"
    },
    width10: {
        width: "10%"
    },
    width125: {
        width: "12.5%"
    },
    width13: {
        width: "13%"
    },
    width149: {
        width: "14.9%"
    },
    width15: {
        width: "15%"
    },
    width22: {
        width: "22%"
    },
    width25: {
        width: "25%"
    },
    width40: {
        width: "40%"
    },
    width43: {
        width: "43%"
    },
    width50: {
        width: "50%"
    },
    width52: {
        width: "52%"
    },
    width75: {
        width: "75%"
    },
    width85: {
        width: "85%"
    },
    width100: {
        width: "100%",
    },
    footerPadding: {
        paddingTop: 12,
        // paddingBottom: 5,
        letterSpacing: 4,
        color: KEY_FONT_COLOR
    },
    padding2: {
        padding: 2
    },
    padding4: {
        padding: 4
    },
    paddingTop7: {
        paddingTop: 7
    },
    marginBottom4: {
        marginBottom: 4
    },
    marginBottom8: {
        marginBottom: 8
    },
    marginTopBtm5: {
        marginBottom: 5,
        marginTop: 5
    },
    marginTop3: {
        marginTop: 3
    },
    marginTop5: {
        marginTop: 5
    },
    marginTop8: {
        marginTop: 8
    },
    marginTop10: {
        marginTop: 10
    },
    marginTop30: {
        marginTop: 30
    },
    fontSize8: {
        fontSize: 8
    },
    fontSize10: {
        fontSize: 10
    },
    fontSize12: {
        fontSize: 12
    },
    textCenter: {
        textAlign: "center"
    },
    textRight: {
        textAlign: "right"
    },
    backgroundText: {
        backgroundColor: '#EBEBEB',
        padding: 5,
        borderRadius: 3
    },
    tableHeader: {
        backgroundColor: TABLE_HEADER_COLOR
    },
    tableCellKey: {
        color: KEY_FONT_COLOR
    },
    backgroundBlack: {
        backgroundColor: BLACK,
        color: WHITE,
    },
    height30p: {
        height: '15.4%'
    },
    image: {
        height: '13%',
        width: '100%',
        backgroundColor: '#ffffff'
    }
});
let preShipmentStoreData;
const PreShipmentInvoicePdf = () => {
    const companyId = companyData().getCompanyData();
    let { preShipmentInvoiceId } = useParams<any>();
    const [loading, setLoadingCurrency] = useState<boolean>(true);
    const history = useHistory();
    const location = useLocation();
    const onChangeManufacture = (manufactureDetailsId, manufactureDetailData) => {
        const manuFactureIndex = manufactureDetailData.findIndex((eachPOInvoice) => eachPOInvoice['_id'] === manufactureDetailsId);
        if (manuFactureIndex != undefined && manuFactureIndex !== -1) {
            const manufactureDetail = manufactureDetailData[manuFactureIndex].businessPartnerId
            preShipmentStoreData.manuFactureDetailsConst = {
                name: manufactureDetail.name,
                address: manufactureDetail.address,
                phoneNumber: manufactureDetail.phoneNumber,
                email: manufactureDetail.email
            };
        }
    }
    useEffect(() => {
        preShipmentStoreData = useStore.getState().psiData;
        const manufactureDetailData = useStore.getState().manufactureDetailData;
        if (manufactureDetailData && manufactureDetailData.length) {
            onChangeManufacture(preShipmentStoreData.manufactureDetails, manufactureDetailData);
        }
        if (location.pathname.split('/').length === 3) {
            if (!preShipmentStoreData) {
                history.push(routeConfig.preShipmentList.path)
            } else {
                preShipmentInvoiceId = preShipmentStoreData['_id'];
                fetch('https://openexchangerates.org/api/currencies.json')
                    .then(response => response.json())
                    .then(data => Object.entries(data).forEach(([key, value]) => {
                        if (key === preShipmentStoreData.currency) {
                            preShipmentStoreData.currencyvalue = value;
                            preShipmentStoreData.amountInWords = convertNumTOWords(preShipmentStoreData.totalAmount, preShipmentStoreData.currencyvalue);
                            setLoadingCurrency(false);
                        }
                    }));
            }
        }
    }, []);
    return (
        <>
            {
                loading ? <Skeleton active /> :
                    <PDFViewer style={{ height: '100%', width: '100%' }} >
                        <MyDocument preShipmentStoreData={preShipmentStoreData} />
                    </PDFViewer>
            }
        </>
    );
}

{/* */ }
export default PreShipmentInvoicePdf

const MyDocument = ({ preShipmentStoreData }) => (
    <Document title="Pre-Shipment Invoice" >
        <Page size="A4">
            <Image src={header} style={[styles.image]} />
            <View style={[styles.backgroundBlack, styles.padding4]}>
                <Text style={[styles.fontSize12, , styles.textCenter]}>PRESHIPMENT INVOICE</Text>
            </View>
            <View style={styles.body}>
                <View style={[styles.table]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Invoice No</Text>
                            <Text style={[styles.tableCell]}>{preShipmentStoreData.invoiceNumber}</Text>
                        </View>

                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Invoice Date</Text>
                            <Text style={[styles.tableCell]}>{preShipmentStoreData.date}</Text>
                        </View>

                        <View style={[styles.tableCol, styles.width50]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Exporter Ref No.</Text>
                            <Text style={[styles.tableCell]}>{preShipmentStoreData.exporterRefNo.invoiceNumber}</Text>
                        </View>

                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width50]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Customer PO No.</Text>
                            <Text style={[styles.tableCell]}>{preShipmentStoreData.customerPoNumber}</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width50]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Customer PO Date</Text>
                            <Text style={[styles.tableCell]}>{preShipmentStoreData.customerPoDate}</Text>
                        </View>

                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width50, styles.height90]}>
                            <Text style={[styles.tableCell, styles.tableCellKey]}>Consignee</Text>
                            <Text style={styles.tableCell}>{preShipmentStoreData.businessPartnerId.name}</Text>
                            <Text style={styles.tableCellSmall}>{preShipmentStoreData.businessPartnerId.address} </Text>
                            {/* <Text style={styles.tableCellSmall}>{preShipmentStoreData.businessPartnerId.phoneNumber}</Text>
                            <Text style={styles.tableCellSmall}>{preShipmentStoreData.businessPartnerId.email}</Text> */}
                        </View>
                        <View style={[styles.tableCol, styles.width50, styles.height90]}>
                                <Text style={[styles.tableCell, styles.tableCellKey]}>Buyer</Text>
                                <Text style={styles.tableCell}>{preShipmentStoreData.buyer.name}</Text>
                                <Text style={styles.tableCellSmall}>{preShipmentStoreData.buyer.address} </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Method of Dispatch</Text>
                            <Text style={styles.tableCell}>{preShipmentStoreData.methodOfDispatch.shippingMode} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Vessel/Flight No</Text>
                            <Text style={styles.tableCell}>{preShipmentStoreData.vesselNo} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Scheduled Delivery</Text>
                            <Text style={styles.tableCell}>{preShipmentStoreData.scheduledDelivery}</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Currency</Text>
                            <Text style={styles.tableCell}>{preShipmentStoreData.currencyvalue}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Origin Country</Text>
                            <Text style={[styles.tableCell]}>{preShipmentStoreData.countryOfOrigin.country} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Destination Country </Text>
                            <Text style={styles.tableCell}>{preShipmentStoreData.countryOfDestination.country} </Text>
                        </View>
                        <View style={[styles.tableCol, preShipmentStoreData.finalDestination ? styles.width25 : styles.width50]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Delivery Terms</Text>
                            <Text style={styles.tableCell}>{preShipmentStoreData.deliveryTerms.deliveryTerm} </Text>
                        </View>
                        {
                            preShipmentStoreData.finalDestination && (
                                <View style={[styles.tableCol, styles.width25]}>
                                    <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Final Destination</Text>
                                    <Text style={styles.tableCell}>{preShipmentStoreData.finalDestination.country}</Text>
                                </View>
                            )
                        }
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Port of Loading</Text>
                            <Text style={styles.tableCell}>{preShipmentStoreData.portOfLoading.port}, {preShipmentStoreData.portOfLoading.country} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Port of Destination</Text>
                            <Text style={styles.tableCell}>{preShipmentStoreData.portOfDischarge.port}, {preShipmentStoreData.portOfDischarge.country} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width50]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Payment Terms</Text>
                            <Text style={styles.tableCell}>{preShipmentStoreData.paymentTerms.paymentTerm} </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width15, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>HS Code</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width22, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Description of Goods </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width13, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Packing Type</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Quantity</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>No Of Packages</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width833, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Unit Type</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width833, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Rate ({preShipmentStoreData.currency})</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width833, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Amount</Text>
                        </View>
                    </View>
                    <View>
                        {
                            preShipmentStoreData.pfiItemDetails?.map((r, i) => {
                                return (
                                    <View key={i}>
                                        <View style={styles.tableRow}>
                                            <View style={[styles.tableCol, styles.width15, styles.textLeft]}>
                                                <Text style={styles.tableCell}>{r.descriptionOfGoods.hsCode}</Text>
                                            </View>
                                            <View style={[styles.tableCol, styles.width22]}>
                                                <Text style={styles.tableCell}>{r.descriptionOfGoods.productName}</Text>
                                                {(r?.comments || r?.comments === '') && (
                                                    <Text style={[styles.fontSize8, styles.tableCellKey]}>{r.comments}</Text>
                                                )}
                                            </View>
                                            <View style={[styles.tableCol, styles.width13, styles.textLeft]}>
                                                <Text style={styles.tableCell}>{r.packingTypes.packingType}</Text>
                                            </View>
                                            <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                                                <Text style={styles.tableCell}>{fixedDecimal(r.quantity)}</Text>
                                            </View>
                                            <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                                                <Text style={styles.tableCell}>{fixedDecimal(r.noOfPackages)}</Text>
                                            </View>
                                            <View style={[styles.tableCol, styles.width833, styles.textRight]}>
                                                <Text style={styles.tableCell}>{r.unitType}</Text>
                                            </View>
                                            <View style={[styles.tableCol, styles.width833, styles.textRight]}>
                                                <Text style={styles.tableCell}>{fixedDecimal(r.rate)}</Text>
                                            </View>
                                            <View style={[styles.tableCol, styles.width833, styles.textRight]}>
                                                <Text style={styles.tableCell}>{fixedDecimal(r.amount)}</Text>
                                            </View>
                                        </View>
                                    </View>
                                )
                            })
                        }
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width50, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3, styles.fontSize8, styles.tableCellKey]}>Consignment Total Quantity</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3]}>{fixedDecimal(preShipmentStoreData.totalQuantity)}</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3, styles.fontSize8, styles.tableCellKey]}>Amount Total ({preShipmentStoreData.currency})</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width125, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3]}>{fixedDecimal(preShipmentStoreData.totalAmount)}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width15, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3, styles.fontSize8, styles.tableCellKey]}>Amount in Words</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width85]}>
                            <Text style={[styles.tableCell, styles.margin3]}>{preShipmentStoreData.amountInWords}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width15, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3, styles.fontSize8, styles.tableCellKey]}>Container No.</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width85]}>
                            <Text style={[styles.tableCell, styles.margin3]}>{preShipmentStoreData.containerNo}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width15, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3, styles.fontSize8, styles.tableCellKey]}>Seal No.</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width85]}>
                            <Text style={[styles.tableCell, styles.margin3]}>{preShipmentStoreData.sealNo}</Text>
                        </View>
                    </View>


                    <View style={styles.tableRow}>
                        <View style={[styles.tableColNoRight, styles.width25, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3, styles.fontSize8, styles.tableCellKey]}>Drawback (AIR)(%) </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.margin3]}>{fixedDecimal(preShipmentStoreData.shipmentUnderDutyDrawback)}</Text>
                        </View>
                        <View style={[styles.tableColNoLeftTop, styles.width50, styles.textCenter]}>
                            <Text style={[styles.tableCell, styles.margin3]}>FOB/CFR/CIF Break up</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableColNoRight, styles.width25, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3, styles.fontSize8, styles.tableCellKey]}>Tariff Code:</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.margin3]}>{preShipmentStoreData.tarriffRate}</Text>
                        </View>
                        <View style={[styles.tableColNoRight, styles.width25, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>{preShipmentStoreData.deliveryTerms.deliveryTerm} Price</Text>
                        </View>
                        <View style={[styles.tableColNoLeftTop, styles.width25, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3]}>{fixedDecimal(preShipmentStoreData.breakUpAmount.cfrValue)}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, styles.height51]}>
                        <View style={[styles.tableCol, styles.width50, styles.height51]}>
                            <Text style={styles.tableCell}>{preShipmentStoreData.gstSchema}</Text>
                        </View>
                        <View style={[styles.tableColNoPadding, styles.width50, styles.height51]}>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Less Freight:</Text>
                                </View>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={styles.tableCell}>{fixedDecimal(preShipmentStoreData.breakUpAmount.freight)}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Less:Insurance</Text>
                                </View>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={styles.tableCell}>{fixedDecimal(preShipmentStoreData.breakUpAmount.insurance)}</Text>
                                </View>
                            </View>
                        </View>

                    </View>
                    <View style={[styles.tableRow, styles.height80]}>
                        <View style={[styles.tableCol, styles.width50]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Manufacture Details</Text>
                            {/* <Text style={styles.tableCell}>{preShipmentStoreData.manufactureDetails}</Text> */}
                            {
                                preShipmentStoreData.manuFactureDetailsConst &&
                                <View>
                                    <Text style={styles.tableCell}>{preShipmentStoreData.manuFactureDetailsConst.name}</Text>
                                    <Text style={styles.tableCellSmall}>{preShipmentStoreData.manuFactureDetailsConst.address} </Text>
                                    <Text style={styles.tableCellSmall}>{preShipmentStoreData.manuFactureDetailsConst.phoneNumber}</Text>
                                    <Text style={styles.tableCellSmall}>{preShipmentStoreData.manuFactureDetailsConst.email}</Text>
                                </View>
                            }

                        </View>
                        <View style={[styles.tableColNoPadding, styles.width50]}>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Less: Commission </Text>
                                </View>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={styles.tableCell}>{fixedDecimal(preShipmentStoreData.breakUpAmount.commission)}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height255]}>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Total FOB Price ({preShipmentStoreData.currency})</Text>
                                </View>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={styles.tableCell}>{fixedDecimal(preShipmentStoreData.breakUpAmount.fobValue)}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height255]}>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Exchange Rate</Text>
                                </View>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={styles.tableCell}>{fixedDecimal(preShipmentStoreData.breakUpAmount.exchangeRate)}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height255]}>
                                <View style={[styles.tableColNoBorder, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Total FOB Price in INR</Text>
                                </View>
                                <View style={[styles.tableColNoBorder, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={styles.tableCell}>{fixedDecimal(preShipmentStoreData.breakUpAmount.fobValueInInr)}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, styles.height20]}>
                        <View style={[styles.tableCol, styles.width100]}>
                            <Text style={[styles.tableCell, styles.textCenter, styles.fontSize8]}>{preShipmentStoreData.gstMessage}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, styles.height25]}>
                        <View style={[styles.tableCol, styles.width100]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Term & Condition</Text>
                            <Text style={[styles.tableCellSmall]}>{preShipmentStoreData.termsAndConditions}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, styles.height60]}>
                        <View style={[styles.tableCol, styles.width75]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Declaration</Text>
                            <Text style={styles.tableCell}>{preShipmentStoreData.declaration}</Text>
                        </View>
                        <View style={[styles.tableColNoPadding, styles.width25]}>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoBorder, styles.width100, styles.textRight]}>
                                    <Text style={[styles.tableCell]}>For, Chemtrade</Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoBorder, styles.width100, styles.marginTop8, styles.textRight]}>
                                    {/* <Text style={[styles.tableCell]}>For, Chemtrade</Text> */}
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoBorder, styles.width100, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell]}>Authorized Signature/Name</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
            {/* footer */}
            <View style={[styles.footerPadding, styles.marginBottom4]}>
                <Text style={[styles.fontSize10, styles.textCenter]}>
                Industrial Chemicals | APIs
                        </Text>
            </View>
            <View style={[styles.backgroundBlack, styles.padding4]}>
                <Text style={[styles.fontSize10, styles.textCenter]}>
                    Plot No: 38, Kalathiya Corp. V-2, Diamond Nagar, Kholwad, Surat, Gujarat, India - 394180
                </Text>
            </View>
        </Page>
    </Document >
);
